import React, { useState } from 'react';
import { X, Bell, Clock, CheckCircle, Send, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const UnavailableCourseModal = ({ isOpen, onClose, course, user }) => {
  const [form, setForm] = useState({
    name: user?.name || '',
    email: user?.email || '',
    whatsapp: user?.whatsapp || ''
  });
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.name || !form.email) {
      setError('Preencha nome e e-mail.');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/course-interest/lead`, {
        course_id: course.course_id,
        name: form.name,
        email: form.email,
        whatsapp: form.whatsapp
      });
      if (response.data.success) {
        setRegistered(true);
      }
    } catch (err) {
      setError('Não foi possível registrar agora. Tente novamente em instantes.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="course-interest-modal">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-zinc-900 border border-zinc-800 rounded-2xl max-w-md w-full mx-4 overflow-hidden">
        <div className="bg-gradient-to-r from-amber-600 to-orange-600 p-6 text-center">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Clock className="text-white" size={32} />
          </div>
          <h2 className="text-2xl font-bold text-white">Em Breve!</h2>
        </div>

        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
          data-testid="course-interest-close"
        >
          <X size={24} />
        </button>

        <div className="p-6">
          <h3 className="text-xl font-bold text-white mb-2 text-center">{course?.title}</h3>

          {registered ? (
            <div className="bg-green-900/30 border border-green-500/30 rounded-xl p-5 text-center" data-testid="course-interest-success">
              <CheckCircle className="text-green-500 mx-auto mb-2" size={36} />
              <p className="text-green-400 font-medium">Recebemos seu interesse!</p>
              <p className="text-gray-400 text-sm mt-1">
                Enviamos um e-mail de confirmação e nossa equipe entrará em contato em breve.
              </p>
              <Button onClick={onClose} className="mt-4 w-full bg-zinc-700 hover:bg-zinc-600 text-white">
                Fechar
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-gray-400 text-center text-sm">
                Cadastre seus dados para ser avisado(a) e receber informações assim que este curso estiver disponível.
              </p>
              <Input
                name="name"
                placeholder="Seu nome completo"
                value={form.name}
                onChange={handleChange}
                className="bg-zinc-800 border-zinc-700 text-white"
                data-testid="course-interest-name"
              />
              <Input
                name="email"
                type="email"
                placeholder="Seu melhor e-mail"
                value={form.email}
                onChange={handleChange}
                className="bg-zinc-800 border-zinc-700 text-white"
                data-testid="course-interest-email"
              />
              <Input
                name="whatsapp"
                placeholder="WhatsApp (com DDD)"
                value={form.whatsapp}
                onChange={handleChange}
                className="bg-zinc-800 border-zinc-700 text-white"
                data-testid="course-interest-whatsapp"
              />
              {error && <p className="text-red-400 text-sm" data-testid="course-interest-error">{error}</p>}
              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-red-600 hover:bg-red-700 text-white py-5"
                data-testid="course-interest-submit"
              >
                {loading ? (
                  <><Loader2 className="mr-2 animate-spin" size={20} /> Registrando...</>
                ) : (
                  <><Bell className="mr-2" size={20} /> Avise-me quando disponível</>
                )}
              </Button>
            </form>
          )}

          <p className="text-gray-500 text-xs text-center mt-4">
            Enquanto isso, explore nossos outros cursos disponíveis!
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnavailableCourseModal;
